import type {PostInfoApiArgs, ViewMode} from '../types';

export const mapViewMode = (viewmode?: ViewMode): PostInfoApiArgs['type'] => {
  if (viewmode === 'work') {
    return 'WORK';
  }

  // Api also defaults to MANIFESTATION
  return 'MANIFESTATION';
};
